var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2631_25063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z",
    fill: "#D9ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4999 19.9389C21.9955 19.9389 20.0649 21.3556 18.9887 22.3479C18.8283 22.4957 18.5799 22.4959 18.4243 22.3431L16.735 20.684C16.5753 20.5272 16.5739 20.2705 16.7375 20.1179C18.0247 18.9164 20.739 16.7998 24.4999 16.7998C28.2609 16.7998 30.9751 18.9164 32.2624 20.1179C32.426 20.2705 32.4246 20.5272 32.2649 20.684L30.5756 22.3431C30.42 22.4959 30.1715 22.4957 30.0112 22.3479C28.935 21.3556 27.0044 19.9389 24.4999 19.9389ZM12.0027 25.5539C11.8363 25.4042 11.8251 25.1472 11.9779 24.9837L13.5918 23.2546C13.7406 23.0952 13.9897 23.0844 14.1518 23.2303L18.9173 27.5204C19.0684 27.6564 19.2975 27.6575 19.4499 27.5228L24.2351 23.2933C24.3863 23.1596 24.6135 23.1596 24.7648 23.2933L29.55 27.5228C29.7023 27.6575 29.9315 27.6564 30.0826 27.5204L34.8481 23.2303C35.0102 23.0844 35.2593 23.0952 35.4081 23.2546L37.022 24.9837C37.1747 25.1472 37.1635 25.4042 36.9972 25.5539L30.1023 31.7611C29.9512 31.8971 29.7221 31.8981 29.5698 31.7635L24.7648 27.5165C24.6135 27.3828 24.3863 27.3828 24.2351 27.5165L19.4301 31.7635C19.2778 31.8981 19.0487 31.8971 18.8976 31.7611L12.0027 25.5539Z",
    fill: "#278FFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_25063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.8aaa33bb9d0588857f31e49ea318f8f2.svg";
export { ForwardRef as ReactComponent };